import React from "react";
import { Separator } from "@/components/ui/separator";
import { Globe, Building2, TrendingUp, Users, AlertTriangle } from "lucide-react";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const VisionSection: React.FC = () => {
  return <div className="p-12 h-full">
      <h2 className="text-3xl font-bold text-noa-rich-black mb-6">LatAm's Two‑Sided Coin — Big Tailwinds, Manageable Risks
    </h2>
      <Separator className="mb-8 bg-gray-200" />
      
      
      
      <div className="mb-10">
        
        
        <p className="text-gray-700 mb-6">The Built‑In Hedge: We acquire <span className="font-bold">mission‑critical</span> VMS leaders in <span className="font-bold">fast‑digitizing</span>, <span className="font-bold">double-digit growth</span> niches at entry multiples <span className="font-bold">below 7× EBITDA</span>—representing a <span className="font-bold">~50% discount</span> vs comparables in the US/EU. Low valuations and embedded growth offer a natural hedge against macro risk; everything else is upside.</p>
        
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-4">
            <TrendingUp className="w-5 h-5 text-blue-500" />
            <h3 className="text-xl font-semibold text-noa-rich-black">Why Acquired Assets Grow Double Digits — Organically</h3>
          </div>
          
          <div className="overflow-x-auto">
            <Table className="w-full border-collapse">
              <TableHeader>
                <TableRow className="bg-gray-100">
                  <TableHead className="w-1/3 font-semibold text-noa-rich-black border border-gray-200">Tailwind</TableHead>
                  <TableHead className="w-2/3 font-semibold text-noa-rich-black border border-gray-200">Impact</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">Regulatory Formalisation</TableCell>
                  <TableCell className="border border-gray-200">Regulatory compliance mandates are driving SaaS adoption.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">Post-COVID Digital Surge</TableCell>
                  <TableCell className="border border-gray-200">Pandemic digitization accelerates SaaS uptake in lagging sectors.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">Nearshoring & FDI</TableCell>
                  <TableCell className="border border-gray-200">U.S. supply‑chain shifts create new formal businesses—expanding TAM.</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">SMB Greenfield</TableCell>
                  <TableCell className="border border-gray-200">Enterprise is served—vast SMB base remains under-digitised.</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </div>

        <div className="mt-10">
          <div className="flex items-center gap-2 mb-4">
            <AlertTriangle className="w-5 h-5 text-amber-500" />
            <h3 className="text-xl font-semibold text-noa-rich-black">Locking-In Upside & Capping Downside</h3>
          </div>
          
          <div className="overflow-x-auto">
            <Table className="w-full border-collapse">
              <TableHeader>
                <TableRow className="bg-gray-100">
                  <TableHead className="w-1/3 font-semibold text-noa-rich-black border border-gray-200">Risk / Challenge</TableHead>
                  <TableHead className="w-2/3 font-semibold text-noa-rich-black border border-gray-200">Mitigation Playbook</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">Inflation</TableCell>
                  <TableCell className="border border-gray-200">CPI-indexed pricing with annual resets</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">FX Volatility</TableCell>
                  <TableCell className="border border-gray-200">USD treasury buffer; dollar-linked accounts</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">Weak Governance</TableCell>
                  <TableCell className="border border-gray-200">CFO-led book clean-up in the first 90 days post-close</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium border border-gray-200">Macro Cyclicality</TableCell>
                  <TableCell className="border border-gray-200">Focus on recession-resilient, non-discretionary verticals</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
          
          <div className="mt-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded-r-md">
            <p className="text-blue-800 font-semibold">Take‑away: High‑growth assets bought cheap, plus disciplined risk controls, deliver superior risk‑adjusted IRR.</p>
          </div>
        </div>
      </div>
      
    </div>;
};
export default VisionSection;